import { useState } from 'react'

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [animation, setAnimation] = useState<
    'appear' | 'disappear' | undefined
  >(undefined)

  const openModal = () => {
    setAnimation('appear')
    setIsOpen(true)
  }

  const closeModal = () => {
    setAnimation('disappear')
    setIsOpen(false)
  }

  return { isOpen, animation, openModal, closeModal }
}
